import React from 'react';
import ThemeProvider from './context/ThemeProvider';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router } from 'react-router-dom';
import { BrowserRouter as BroRouter,Routes,Route } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode >
    <ThemeProvider>
        <Router>
          <App />
        </Router>      
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
